import Splide from "@splidejs/splide";
import { findParentWithAttribute } from "../../utils/dom";

const $html = getComputedStyle(document.querySelector("html") as HTMLElement);

const getSplideOptions = ($el: HTMLElement) => {
  const perPage = parseInt($el.dataset.cols ?? "4", 0);

  const defaultOptions = {
    pagination: false,
    gap: $html.getPropertyValue("--spacingLarge"),
    perPage,
    breakpoints: {
      600: {
        gap: $html.getPropertyValue("--spacingDefault"),
        padding: 32,
        perPage: 1,
      },
      1024: {
        gap: $html.getPropertyValue("--spacingDefault"),
        perPage: perPage > 1 ? 2 : 1,
      },
    },
  };

  const $parentBlock = findParentWithAttribute($el, "data-area-col-span");

  if (parseInt($parentBlock?.dataset.areaColSpan || "", 10) <= 6) {
    return {
      perPage: 2,
      breakpoints: defaultOptions.breakpoints,
    };
  }

  return defaultOptions;
};

export default () => {
  const gridCarousels
    = document.querySelectorAll<HTMLElement>(".js-grid-carousel");

  gridCarousels.forEach(($el: HTMLElement) => {
    new Splide($el, getSplideOptions($el)).mount();
  });
};
